// Based on your Python backend models - FIXED VERSION

export enum EventRole {
  ATTENDEE = 'attendee',
  ORGANIZER = 'organization',
  PROMOTER = 'promoter',  // Keep if needed
  ADMIN = 'admin',
  SYSTEM = 'system',  // Add this
}


export enum SubscriptionTier {
  FREE = 'free',
  BASIC = 'basic',  // ✅ Add this
  PREMIUM = 'premium',
  ENTERPRISE = 'enterprise',
}


export interface User {
  accessToken: any;
  id: string;
  documentId: string;
  user_id: string;
  email: string;
  name: string;
  userType: EventRole;
  username: string;
  subscriptions: SubscriptionTier;
  email_verified: boolean;
  confirmed: boolean;
  phone?: string;
  phone_verified?: boolean;
  company?: string;
  bio?: string;
  createdAt: string;
  last_login?: string;
}

export interface AuthState {
  user: User | null;
  token: string | null;
  isAuthenticated: boolean;
  loading: boolean;
  error: string | null;
  // Mobile OTP state
  otpSent: boolean;
  otpPhone: string | null;
  // Password reset state
  resetEmailSent: boolean;
}

// ============================================
// REQUEST TYPES
// ============================================

export interface LoginRequest {
  identifier: string;
  password: string;
}

export interface RegisterRequest {
  email: string;
  password: string;
  name: string;
  username:string;
  userType: EventRole;
  subscriptions?: SubscriptionTier;
  phone?: string;
  company?: string;
  bio?: string;
}

export interface UpdateProfileRequest {
  name?: string;
  phone?: string;
  company?: string;
  bio?: string;
}

// Mobile OTP
export interface MobileOTPRequest {
  phone: string;
}

export interface MobileOTPVerify {
  phone: string;
  otp: string;
  name?: string;
}

export interface MobileOTPResend {
  phone: string;
}

// Password management
export interface ForgotPasswordRequest {
  email: string;
}

export interface ResetPasswordRequest {
  code: string;
  password: string;
  passwordConfirmation: string;
}

export interface ChangePasswordRequest {
  currentPassword: string;
  password: string;
  passwordConfirmation: string;
}

// Social auth
export interface FirebaseSocialAuthRequest {
  firebase_token: string;
  provider: 'google' | 'github';
}

// ============================================
// RESPONSE TYPES
// ============================================

export interface TokenResponse {
  token: any;
  jwt: string;
  token_type: string;
  expires_in: number;
  user: User;
}

export interface UserResponse extends User {}

export interface OTPResponse {
  success: boolean;
  message: string;
  expires_in?: number;
}

export interface PasswordResetResponse {
  success: boolean;
  message: string;
}

export interface AuthConfigResponse {
  otp_enabled: boolean;
  social_auth_enabled: boolean;
  google_client_id?: string;
  firebase_config?: {
    apiKey: string;
    authDomain: string;
    projectId: string;
  };
}
